<portal-sub-nav [force]="force" route="system-admin-device">
  <!-- Device firmwares -->
  <portal-sub-nav-item [routeExact]="true" route="system-admin-device-firmwares">
    <ng-template portalTransclude>
      <span>{{ 'menu.deviceFirmwares' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Device models -->
  <portal-sub-nav-item [activeRoutes]="['system-admin-device']" route="system-admin-device-models">
    <ng-template portalTransclude>
      <span>{{ 'menu.deviceModels' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Device series -->
  <portal-sub-nav-item route="system-admin-device-series">
    <ng-template portalTransclude>
      <span>{{ 'menu.deviceSeries' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Device manufacturers -->
  <portal-sub-nav-item route="system-admin-device-manufacturers">
    <ng-template portalTransclude>
      <span>{{ 'menu.deviceManufacturers' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>
</portal-sub-nav>
